import React, { useState, useContext } from "react";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import instance from "../../utils/customInstance";
import { useNavigate } from "react-router-dom";
import Bread from "../../common/Bread";
import contactSVG from "../../assets/contactSVG.svg";
import { ClipLoader } from "react-spinners";
import grievancess from "../../assets/information/grievOfficer.jpg";
import informationss from "../../assets/information/infoOfficer.jpg";
import "./grievanceForm.scss";
import { LangContext } from "../../context/LangContext";
import { is } from "date-fns/locale";

const GrievanceForm = () => {
  const { state } = useContext(LangContext);
  const isNepali = state?.np;

  const breadcrumList = {
    image: "",
    link: "",
    title: isNepali ? "गुनासो" : "Grievance",
    l1: isNepali ? "गृहपृष्ठ" : "Home",
    l2: isNepali ? "गुनासो" : "Grievance",
    l3: "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [verificationLoad, setVerificationLoad] = useState(false);
  const [vCode, setVCode] = useState();
  const [convert, setConvert] = useState();

  const navigate = useNavigate();

  const convert2base64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => setConvert(reader.result.toString());
    reader.readAsDataURL(file);
  };

  const handleFileChange = (e) => {
    convert2base64(e.target.files[0]);
  };

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      if (!verificationLoad) {
        const { data } = await instance.post("grievance/otp", {
          ...values,
          resume: convert,
        });

        if (data?.error) {
          toast.error(data.error);
        } else {
          toast.success(
            isNepali
              ? "कृपया इमेल जाँच गरी प्रमाणीकरण कोड प्रविष्ट गर्नुहोस्।"
              : "Please Check Your Email and type your verification code here.",
          );
          setVCode(data.otp_code);
        }
      } else {
        if (Number(values.verification) === vCode) {
          const { data } = await instance.post("grievance/form", {
            ...values,
            DocPath: convert,
          });

          if (data?.error) {
            toast.error(data.error);
          } else {
            toast.success(
              isNepali
                ? "सन्देश सफलतापूर्वक पठाइयो।"
                : "Message Successfully Sent.",
            );
            navigate("/GrievanceResForm");
          }
        } else {
          toast.error(
            isNepali
              ? "प्रमाणीकरण कोड मिलेन। पुनः प्रयास गर्नुहोस्।"
              : "The verification code does not match. Please try again",
          );
        }
      }
    } catch (err) {
      toast.error(
        isNepali
          ? "पठाउन असफल भयो। पुनः प्रयास गर्नुहोस्।"
          : "Failed to send. Please try again.",
      );
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (isSubmitSuccessful) setVerificationLoad(true);
  }, [isSubmitSuccessful]);

  return (
    <Bread data={breadcrumList}>
      <div>
        <div className="grievanceFormMainContainer">
          <img
            className="grievanceFormImage"
            src={contactSVG}
            alt="contact svg"
          />

          <div className="grievancePageFormContainer">
            <h3>
              {verificationLoad
                ? isNepali
                  ? "कृपया तपाईंको इमेलमा आएको कोड प्रविष्ट गर्नुहोस्"
                  : "Please find the code on the email you provided"
                : isNepali
                  ? "हामी तपाईंलाई कसरी सहयोग गर्न सक्छौं?"
                  : "How may We help you?"}
            </h3>

            <form
              onSubmit={handleSubmit(onSubmit)}
              encType="multipart/form-data"
            >
              {!verificationLoad && (
                <>
                  <div className="grievanceFormInputContainer">
                    <label>{isNepali ? "पूरा नाम" : "Full Name"}</label>
                    <input
                      type="text"
                      placeholder={isNepali ? "पूरा नाम" : "Full Name"}
                      {...register("name", { required: true })}
                    />
                  </div>

                  <div className="grievanceFormInputContainer">
                    <label>{isNepali ? "इमेल ठेगाना" : "Email Address"}</label>
                    <input
                      type="text"
                      placeholder={isNepali ? "इमेल ठेगाना" : "Email Address"}
                      {...register("email", { required: true })}
                    />
                  </div>

                  <div className="grievanceFormInputContainer">
                    <label>{isNepali ? "मोबाइल नम्बर" : "Mobile Number"}</label>
                    <input
                      type="number"
                      placeholder={isNepali ? "मोबाइल नम्बर" : "Mobile Number"}
                      {...register("mobno", { required: true })}
                    />
                  </div>

                  <div className="grievanceFormInputContainer">
                    <label>{isNepali ? "शाखा" : "Branch"}</label>
                    <input
                      type="text"
                      placeholder={
                        isNepali ? "शाखाको नाम" : "Enter branch name"
                      }
                      {...register("branch_name", { required: true })}
                    />
                  </div>

                  <div className="grievanceFormInputContainer">
                    <label>{isNepali ? "विषय" : "Subject"}</label>
                    <input
                      type="text"
                      placeholder={isNepali ? "विषय" : "Subject"}
                      {...register("subject", { required: true })}
                    />
                  </div>

                  <div className="grievanceFormInputContainer">
                    <label>
                      {isNepali ? "संलग्न फाइल" : "Attachment file"}
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className="grievanceFormInputContainer">
                    <label>
                      {isNepali ? "तपाईंको सन्देश" : "Your Message"}
                    </label>
                    <textarea
                      rows="5"
                      placeholder={isNepali ? "तपाईंको सन्देश" : "Your Message"}
                      {...register("issue", { required: true })}
                    />
                  </div>
                </>
              )}

              {verificationLoad && (
                <div className="grievanceFormInputContainer">
                  <label>
                    {isNepali
                      ? "इमेल प्रमाणीकरण कोड"
                      : "Email Verification Code"}
                  </label>
                  <input
                    type="text"
                    placeholder={
                      isNepali ? "प्रमाणीकरण कोड" : "Verification Code"
                    }
                    {...register("verification", { required: true })}
                  />
                </div>
              )}

              <div className="grievanceFormButtonsContainer">
                <button
                  className="grievanceFormResetButton grievanceSubmitButton"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {loading && <ClipLoader size={20} color="#fff" />}
                  {isNepali ? "पेश गर्नुहोस्" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="officers-profile">
          <div className="information-profile">
            <div className="i-img">
              <img src={informationss} alt="image" />
            </div>
            <div className="i-details">
              <h2>{isNepali ? "सूचना अधिकारी" : "Information officer"}</h2>
              <h3>{isNepali ? "श्री संजय थपलिया" : "Mr. Sanjaya Thapaliya"}</h3>
              <p>
                {isNepali ? "सहायक महाप्रबन्धक" : "Assistant General Manager"}
              </p>
            </div>
          </div>

          <div className="grievance-profile">
            <div className="i-img">
              <img src={grievancess} alt="image" />
            </div>
            <div className="i-details">
              <h2>{isNepali ? "गुनासो अधिकारी" : "Grievance officer"}</h2>
              <h3>{isNepali ? "श्री अमित श्रेष्ठ" : "Mr. Amit Shrestha"}</h3>
              <p>
                {isNepali
                  ? "नायब प्रमुख कार्यकारी अधिकृत"
                  : "Deputy Chief Executive Officer"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Bread>
  );
};

export default GrievanceForm;
